(function corrigirLocalStorageEscapado(key = 'filtros_busca_imobiliario') {
  try {
    const storage = window.parent?.localStorage || window.localStorage;

    const raw = storage.getItem(key);
    if (!raw) return;

    const looksEscaped = raw.trim().startsWith('"[') || raw.includes('\\"');
    if (!looksEscaped) return;

    const once = JSON.parse(raw);
    if (typeof once === 'string') {
      const fixed = JSON.parse(once);
      if (Array.isArray(fixed)) {
        storage.setItem(key, JSON.stringify(fixed));
      }
    }
  } catch (e) {
    console.warn('[main] ⚠️ Erro ao corrigir localStorage escapado:', e);
  }
})();

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
